import CenterBarNav from "../CenterBarNav";
import ListCellZ from "../../atoms/ListCellZ";
import Inputz from "../../atoms/Inputz";
import TagGroup from "../TagGroup";
import RadioGroup from "../RadioGroup";
import CheckGroup from "../CheckGroup";
import { data } from "../../../data/itemsData";
import Buttonz from "../../atoms/Buttonz";
import { useNavigate } from "react-router-dom";
import SvgIcn from "../../../data/IconCompo";

function HomeLeftBar({ selectedMode }) {
  const navigate = useNavigate();
  const navBtn = (mode) =>
    ["leftBar-button", selectedMode === mode && "selected"].filter(Boolean).join(" ");
  const activeChild = (mode) => (selectedMode === mode ? "selected" : undefined);

  return (
    <div className="leftBar-button-box ">
      <div
        onClick={() => {
          navigate("/tools");
        }}
        className={navBtn("tools")}
      >
        <SvgIcn name="tool" className={activeChild("tools")} />
        <h3 className={activeChild("tools")}>TOOLS</h3>
      </div>
      <div
        onClick={() => {
          navigate("/resos");
        }}
        className={navBtn("resos")}
      >
        <SvgIcn name="resos" className={activeChild("resos")} />
        <h3 className={activeChild("resos")}>RESOS</h3>
      </div>
      <div
        onClick={() => {
          navigate("/ideaz");
        }}
        className={navBtn("ideaz")}
      >
        <SvgIcn name="idea" className={activeChild("ideaz")} />
        <h3 className={activeChild("ideaz")}>IDEAZ</h3>
      </div>
      <div
        onClick={() => {
          navigate("/apps");
        }}
        className={navBtn("apps")}
      >
        <SvgIcn name="apps" className={activeChild("apps")} />
        <h3 className={activeChild("apps")}>APPS</h3>
      </div>
      {/* <div
        onClick={() => {
          navigate("/uudtools");
        }}
        className={navBtn("utools")}
      >
        <SvgIcn name="service_b" className={activeChild("utools")} />
        <h3 className={activeChild("utools")}>UT</h3>
      </div> */}
    </div>
  );
}

export default HomeLeftBar;
